module.exports = __webpack_public_path__ + "static/img/sensor_ultrassonico_hc_sr04-1.198dfb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensor_ultrassonico_hc_sr04-1.svg
// module id = 1Zqc
// module chunks = 0